// alterado - revisado

import React from 'react'

import { 
    IsSmDownScreen
} from '../Service/GlobalService'

export const DivFormN0 = props => {
    return (
        <div 
            className={"border-radius-padrao " + (IsSmDownScreen() ? "p-0" : "mt-1 mb-1 mr-1 ml-2")}
            {...props}
        />
    )
}

export const DivFormN0SemBorderRadius = props => {
    return (
        <div 
            className={IsSmDownScreen() ? "p-0" : "mt-7 mb-1 mr-1 ml-2"}
            {...props}
        />
    )
}

export const DivFormN1 = props => {
    return (
        <div 
            className={"border-radius-padrao " + (IsSmDownScreen() ? "p-1" : "mt-2 mb-1 mr-2 ml-2")}
            {...props}
        />
    )
}

export const DivFormN1SemBorderRadius = props => {
    return (
        <div 
            className={IsSmDownScreen() ? "p-1" : "mt-2 mb-1 mr-2 ml-2"}
            {...props}
        />
    )
}

export const DivForm = props => {
    return (
        <div 
            className="border-radius-padrao p-0"
            {...props}
        />
    )
}

export const DivFormEstudo = props => {
    return (
        <div 
            className="mt-0 mb-6" // mudança da fonte: mt-6
            {...props}
        />
    )
}

export const DivOverflowX = props => {
    return (
        <div 
            className="scroll-x"
            {...props}
        />
    )
}

export const DivOverflowXTabelaPadrao = props => {
    return (
        <div 
            className="scroll-x p-2 pb-4 ml-5 mr-5"
            {...props}
        />
    )
}

export const DivOverflowY = props => {
    return (
        <div 
            className="scroll-y"
            {...props}
        />
    )
}

//export const DivMinW960 = props => {
//    return (
//        <div 
//            className="min-w-960"
//            {...props}
//        />
//    )
//}